import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { List, Card, Avatar, Row, Col, Button, Select, Skeleton } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useQuery } from '@apollo/react-hooks';
import { Link } from 'react-router-dom';
import { CONTRACTORS } from '../graphql/queries/queries';
import _s from './index.less';
import _ from 'lodash';

const { Option } = Select;

const Filters = props => {
  const { prefix, filters, setFilters } = props;

  if (prefix === 'plan') {
    const { data, refetch } = useQuery(CONTRACTORS);
    const contractors = (data && data[Object.keys(data)[0]]) || [];

    const handleChange = (value, field) => {
      setFilters({ ...filters, [field]: value });
    };

    useEffect(() => {
      refetch();
      setFilters({ ...filters, contractorId: '' });
    }, [data]);

    return (
      <div style={{ display: 'block' }}>
        <Row gutter={[16, 16]}>
          <Col span={23}>
            Contractor
            <Select
              defaultValue=""
              style={{ marginLeft: 5, minWidth: 250 }}
              onChange={value => handleChange(value, 'contractorId')}
            >
              <Option key="any" value="">
                Any
              </Option>
              {_.map(contractors, c => (
                <Option key={c.id} value={c.id}>
                  <Avatar style={{ marginRight: 5 }} src={c.logo} />
                  {c.name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
      </div>
    );
  }

  return null;
};

const ListContainer = props => {
  const { prefix, queries, editable = true, canCreate = true, inline = false, CustomCard } = props;
  const [filters, setFilters] = useState({});
  const { data, refetch } = useQuery(queries, {
    variables: { ...filters }
  });
  const items = (data && data[Object.keys(data)[0]]) || [];

  useEffect(() => {
    refetch();
  }, [data, filters]);

  const getActions = item => {
    const actions = [
      <Link key={`link-${item.id}`} to={`/${prefix}/${item.id}`}>
        View
      </Link>
    ];
    if (editable) {
      actions.push(<Link to={`/admin/${prefix}/edit/${item.id}`}>Edit</Link>);
    }
    return actions;
  };

  return (
    <div style={{ display: 'block', marginTop: '2em' }}>
      <Row gutter={[16, 16]}>
        <Col span={23}>
          <Filters {...{ prefix, filters, setFilters, refetch }} />
        </Col>
        {canCreate && (
          <Col span={1} offset={22}>
            <Link to={`/admin/${prefix}/new`}>
              <Button type="primary" shape="round">
                Create
              </Button>
            </Link>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={24}>
          <Card style={{ width: '90vw' }}>
            <List
              grid={!inline && { gutter: 16, column: 4 }}
              dataSource={items}
              pagination={{
                onChange: page => {
                  console.log(page);
                },
                pageSize: 24
              }}
              renderItem={item =>
                CustomCard ? (
                  <List.Item>
                    <CustomCard refetch={refetch} item={item} prefix={prefix} />
                  </List.Item>
                ) : inline ? (
                  <List.Item actions={getActions(item)}>
                    <Skeleton avatar title={false} loading={item.loading} active>
                      <List.Item.Meta
                        avatar={
                          (item.logo || item.image) && <Avatar src={item.logo || item.image} />
                        }
                        title={<Link to={`/${prefix}/${item.id}`}>{item.title || item.name}</Link>}
                        description={item.typeformId || item.ceo || item.description || item.email}
                      />
                    </Skeleton>
                  </List.Item>
                ) : (
                  <List.Item>
                    <Card
                      hoverable
                      cover={
                        (item.logo || item.image) && (
                          <img alt="" src={item.logo || item.image} className={_s.image} />
                        )
                      }
                      actions={getActions(item)}
                    >
                      <Card.Meta
                        title={<Link to={`/${prefix}/${item.id}`}>{item.title || item.name}</Link>}
                        description={item.typeformId || item.ceo || item.description || item.email}
                      />
                    </Card>
                  </List.Item>
                )
              }
            />
          </Card>
          <br />
          Count: {items.length}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

ListContainer.propTypes = {
  user: PropTypes.object.isRequired,
  prefix: PropTypes.string.isRequired,
  queries: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  inline: PropTypes.bool,
  CustomCard: PropTypes.element
};

const connectedList = connect(mapStateToProps, mapDispatchToProps)(ListContainer);

export default connectedList;
